import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/profile/cs_close_n.png'


const _hoisted_1 = { class: "name_pop" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_4 = {
  key: 1,
  class: "errorNotice"
}
const _hoisted_5 = {
  key: 2,
  class: "errorNotice"
}
const _hoisted_6 = { class: "defaultButton" }

import { ref, computed } from 'vue'
import InputField from './inputField.vue'
import { useUserStore } from '@/stores/user'
import StatusPopup from '@/components/common/statusPopup.vue'
import { checkConfirmPasswordValidation, checkPasswordValidation, updatePassword } from '@/view/profile/supportScript'
import MainButton from '../../components/common/mainButton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'passwordChangePopup',
  setup(__props, { expose: __expose }) {

const userStore = useUserStore()
const id = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const password = ref('')
const confirmPassword = ref('')
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const isSubmitBtnActivated = computed(() => {
    return (
        password.value.length > 0 &&
        confirmPassword.value.length > 0 &&
        !passwordValidationNotice.value &&
        !confirmPasswordValidationNotice.value
    );
})
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}

const passwordChange = (value: string) => {
    password.value = value
    checkPasswordValidation(value, passwordValidationNotice)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value, confirmPassword, password, confirmPasswordValidationNotice)
}

const handleUpdatePassword = () => {
    updatePassword(id.value, password.value, show, toastContent, isSuccess, statusRef)
}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'rgb(9, 15, 31)'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_row, { class: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "22",
              style: {"display":"flex","justify-content":"center","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.passwordSetUp')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "2" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: close
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InputField, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
            labelText: _ctx.$t('profile.enterNewPassword'),
            isPassword: true,
            onValueChanged: passwordChange
          }, null, 8, ["modelValue", "labelText"]),
          (passwordValidationNotice.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
            : _createCommentVNode("", true),
          _createVNode(InputField, {
            modelValue: confirmPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
            labelText: _ctx.$t('profile.cnofirmNewPassword'),
            onValueChanged: confirmPasswordChange,
            isPassword: true
          }, null, 8, ["modelValue", "labelText"]),
          (confirmPasswordValidationNotice.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
            : (confirmPassword.value && password.value && confirmPassword.value !== password.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('loginRegister.differentPassword')), 1))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_button, {
              disabled: !isSubmitBtnActivated.value,
              onClick: handleUpdatePassword,
              class: "custom-save-btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createVNode(StatusPopup, {
        ref_key: "statusRef",
        ref: statusRef,
        "is-show-success": isSuccess.value,
        content: toastContent.value
      }, null, 8, ["is-show-success", "content"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})